// extracted by mini-css-extract-plugin
export default {"wrapper":"UATStatusSelect_wrapper__y9gxw"};